// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__ZbpCr","contactIcon":"Contact_contactIcon__ccy4L"};